import { useParams } from "react-router"
import { type RouteArgs } from "@myvp/shared/src/functions/create-route-path"

/**
 * Returns params for a route with slightly different types from `useParams` from `react-router`.
 *
 * The return value will have properties that are typed as `string` and not optional.
 *
 * @param _route expected to be a returned object from `createRoutePath`
 */
export const useRouteParams = <const R extends string>(
  // oxlint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  _route?: {
    route: R
  }
) => {
  return useParams() as RouteArgs<R>
}
